var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.previewMarkdown)?_c('div',{staticClass:"md-toolbar-divider gl-display-flex gl-py-2"},[_c('div',{staticClass:"gl-border-l gl-pl-3 gl-ml-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }